import React, { useState, useEffect, Component } from 'react';
import {PageView, ModalView, Event, Timing} from "../GoogleAnalytics";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
    AssetStateOptions,
    AssetTypeOptions,
    ColumnSortTypes, jsAlert,
    jsAsset,
    jsAsset as classObj,
    workflowHeaders
} from "../../componentObjects";
import DatePicker from "react-datepicker";
import moment from "moment";
import ArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CommonExpandTable from "../CommonTable/CommonExpandTable";
import partnerService from "../../services/partner.service";
import Loader from "../Loader/Loader";
import UpdateAssetClassModal from "../Assets/UpdateAssetClassModal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import AssetService from "../../services/asset.service";
import UpdateTagsModal from "./UpdateTagsModal";
import AlertService from "../../services/alerts.service";
import CommonModal from "../CommonModal/CommonModal";
import Provisioning from "../Provisioning/Provisioning";
import Snackbar from "@mui/material/Snackbar";
import CreateAlertModal from "./CreateAlertModal";

const animatedComponents = makeAnimated();

const partnerOptions = [
    {
        value: 0,
        label: "All Partners"
    },
    {
        value: 1,
        label: "Selected Partner"
    }
];

const assetStateList = ["New", "AwaitingData", "Training", "Trained", "Operational", "Reprovision", "Retrain", "Untrainable"];

function AssetStateTool(props) {
    const { isLoading, _isMounted, loggedInCustomerOrganization, isPartnerAdmin, currentPartnerId, roles } = props;
    const [isMounted, setIsMounted] = useState(false);
    const [contentLoading, setContentLoading] = useState(false);
    const [isSelected, setIsSelected] = useState(-1);
    const [currentAsset, setCurrentAsset] = useState(jsAsset);
    const [filterChanged, setFilterChanged] = useState(false);
    const [assetList, setAssetList] = useState([]);
    const [statusMessage, setStatusMessage] = useState("");
    const [showMessage, setShowMessage] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [assetAlertCount, setAssetAlertCount] = useState(0);
    const [assetEventCount, setAssetEventCount] = useState(0);
    
    const [selectedAssetStateOption, setSelectedAssetStateOption] = useState(AssetStateOptions[0]);
    const [selectedPartnerOption, setSelectedPartnerOption] = useState(partnerOptions[0]);
    const [selectedAssetTypeOption, setSelectedAssetTypeOption] = useState(AssetTypeOptions[0]);
    const [startTime, setStartTime] = useState(moment().subtract(1, 'months'));
    const [endTime, setEndTime] = useState(new moment());
    
    const [showClassModal, setShowClassModal] = useState(false);
    const [appliedClasses, setAppliedClasses] = useState([]);
    const [unappliedClasses, setUnappliedClasses] = useState([]);
    const [applyClassList, setApplyClassList] = useState([]);
    const [removeClassList, setRemoveClassList] = useState([]);
    const [classesLoading, setClassesLoading] = useState(false);
    
    const [showTagModal, setShowTagModal] = useState(false);
    const [appliedTags, setAppliedTags] = useState([]);
    const [unappliedTags, setUnappliedTags] = useState([]);
    const [applyTagList, setApplyTagList] = useState([]);
    const [removeTagList, setRemoveTagList] = useState([]);
    const [tagsLoading, setTagsLoading] = useState(false);
    
    const [showOperationalizeModal, setShowOperationalizeModal] = useState(false);
    const [showTestModal, setShowTestModal] = useState(false);
    const [workflowLoading, setWorkflowLoading] = useState(false);
    
    const [showCreateAlertModal, setShowCreateAlertModal] = useState(false);
    const [newAlert, setNewAlert] = useState(null);
    const [alertTypes, setAlertTypes] = useState([]);
    
    
    useEffect(() => {
        setIsMounted(true);
        setContentLoading(true);
        setFilterChanged(false);
        PageView();

        if (!isLoading) {
            populateAssetData();
        }

        return () => {
            setIsMounted(false);
        };
    }, [isMounted]);

    const populateAssetData = () => {
        if (_isMounted && isMounted) {
            setContentLoading(true);
            setIsSelected(-1);
            setCurrentAsset(jsAsset);
            let requestObj = {
                organization: loggedInCustomerOrganization,
                isPartnerAdmin: isPartnerAdmin,
                isActive: true,
                partnerOrganizationId: selectedPartnerOption.value === 0 ? null : currentPartnerId,
                state: selectedAssetStateOption.value,
                typeId: selectedAssetTypeOption.value,
                assetType: selectedAssetTypeOption.label,
                startDate: startTime.utc(),
                endDate: endTime.utc()
            }
            
            partnerService.getallstateassets(requestObj)
                .then(response => {
                    let list = response.map(asset => ({
                        ...asset,
                        customer: asset.orgName?.split(" / ")[1],
                        partner: asset.orgName?.split(" / ")[0],
                        state: GetAssetClass(asset),
                        ctLabel: GetCTLabel(asset)
                    }));
                    if (selectedAssetStateOption !== AssetStateOptions[0]) {
                        list.filter(l => l.classList !== null && l.classList !== undefined && l.classList.includes(selectedAssetStateOption.value));
                    }
                    setAssetList(list);
                    setContentLoading(false);
                })
                .catch(e => {
                    console.log(e);
                    setContentLoading(false);
                });
        }
    }
    
    const doNothing = () => {
        
    }
    
    // table options helpers
    
    const changeAssetStateFilter = (selectedOption) => {
        setSelectedAssetStateOption(selectedOption);
        setFilterChanged(true);
    }

    const changeAssetTypeFilter = (selectedOption) => {
        setSelectedAssetTypeOption(selectedOption);
        setFilterChanged(true);
    }
    
    const changePartnerFilter = (selectedOption) => {
        setSelectedPartnerOption(selectedOption);
        setFilterChanged(true);
    }
    
    const onChangeStart = (date) => {
        let start = moment(date);
        setStartTime(start);
        setFilterChanged(true);
    }
    
    const onChangeEnd = (date) => {
        let end = moment(date);
        setEndTime(end);
        setFilterChanged(true);
    }
    
    const onApplyFilters = () => {
        //repopulate list
        populateAssetData();
        setFilterChanged(false);
    }
    
    // end table options
    
    // table helpers

    const clearSelected = () => {
        setIsSelected(-1);
        setCurrentAsset(jsAsset);
    }
    
    const onAssetClick = async (index, asset) => {
        let clickedAsset = asset;
        setContentLoading(true);
        if (index !== isSelected) {
            setIsSelected(index);
            setCurrentAsset(asset);

            await AssetService.getassetalertsandevents(clickedAsset.assetId)
                .then(response => {
                    if (response !== null && response !== undefined && response.data !== null && response.data !== undefined) {
                        if (response.data.alertCount !== null && response.data.alertCount !== undefined) {
                            setAssetAlertCount(response.data.alertCount);
                        }
                        else {
                            setAssetAlertCount(0);
                        }
                        if (response.data.eventCount !== null && response.data.eventCount !== undefined) {
                            setAssetEventCount(response.data.eventCount);
                        }
                        else {
                            setAssetEventCount(0);
                        }
                        setContentLoading(false);
                    }
                })
                .catch(e => {
                    console.log(e);
                    setAssetAlertCount(0);
                    setAssetEventCount(0);
                    setContentLoading(false);
                })
        }
        else {
            setIsSelected(-1);
            setCurrentAsset(jsAsset);
            setContentLoading(false);
        }
        
    }

    // end table
    // expand buttons
    
    const onShowClassModal = () => {
        setShowClassModal(!showClassModal);
    }

    const onCancelClassModal = () => {
        setApplyClassList([]);
        setRemoveClassList([]);
    }
    
    const onEditClassesClick = async () => {
        await AssetService.getappliedclasses(currentAsset.assetId)
            .then(async response => {
                setAppliedClasses(response?.data);
                await AssetService.getunappliedclasses(currentAsset.assetId)
                    .then(response2 => {
                        setUnappliedClasses(response2?.data);
                    })
                    .catch(e => {
                        console.log(e);
                    })
            })
            .then(onShowClassModal)
            .catch(e => {
                console.log(e);
            })
    }
    
    const updateClasses = async() => {
        Event("Asset Update Classes", "User clicked update asset class button", "Update Asset Class Clicked");
        setClassesLoading(true);

        await AssetService.applyclasses(currentAsset.assetId, applyClassList)
            .then(async response => {
                console.log(response);
                if (response.data === true) {
                    setStatusMessage("Successfully applied Asset classes!");
                }
                else {
                    setStatusMessage("Failed to apply Asset classes!");
                }
                setShowMessage(true);
                setApplyClassList([]);
    
                await AssetService.removeclasses(currentAsset.assetId, removeClassList)
                    .then(async response2 => {
                        if (response2.data === true) {
                            setStatusMessage("Successfully updated Asset classes!");
                        }
                        else {
                            setStatusMessage("Failed to remove Asset classes!");
                        }
                        setRemoveClassList([]);

                        await AssetService.getappliedclasses(currentAsset.assetId)
                            .then(async response3 => { 
                                let assetAppliedClasses = response3?.data;
                                let updateAssetList = assetList;
                                let updatedAsset = currentAsset;
                                updatedAsset.classList = JSON.stringify(assetAppliedClasses); 
                                updateAssetList[isSelected] = updatedAsset;
                                setAssetList(updateAssetList);

                                setShowClassModal(false);
                                setClassesLoading(false);

                                setTimeout(() => {
                                    setStatusMessage('');
                                    setShowMessage(false);
                                }, 3000);
                            })
                            .catch(e => {
                                console.log(e);
                            })
                        
                    })
                    .catch(e => {
                        console.log(e);
                    });
                
            })
            .catch(e => {
                console.log(e);
                setClassesLoading(false);
            });
    }
    
    const handleApplyClasses = (e) => {
        const classId = e.target.value;
        let newApplyList = applyClassList;

        if (e.target.checked) {
            newApplyList.push(classId);
            setApplyClassList(newApplyList);
        }
        else{
            newApplyList = newApplyList.filter(id => id !== classId);
            setApplyClassList(newApplyList);
        }
    }
    
    const handleRemoveClasses = (e) => {
        const classId = e.target.value;
        let newRemoveList = removeClassList;

        if (e.target.checked) {
            newRemoveList.push(classId);
            setRemoveClassList(newRemoveList);
        }
        else{
            newRemoveList = newRemoveList.filter(id => id !== classId);
            setRemoveClassList(newRemoveList);
        }
    }
    
    const onShowTagModal = () => {
        setShowTagModal(!showTagModal);
    }
    
    const assetworkflowstage = async () => {
        setWorkflowLoading(true);
        const partnerIdList = props.partners.map(partner => partner.organizationId);
        let isallPartners = false;
        if (selectedPartnerOption?.value == 0)
        {
            isallPartners = true ;
        }
        await AssetService.getassetworkflowstage(props.currentPartnerId , partnerIdList,isallPartners )
            .then(response => {
                if (_isMounted) {
                    downloadCSV(response?.data);
                }
            })
            .catch(e => {
                console.log(e);
            })
            .finally(() => {
                setWorkflowLoading(false);
            });
    }
    
    const updateTags = async() => {
        Event("Asset Update Tags", "User clicked update asset tags button", "Update Asset Tags Clicked");
        setTagsLoading(true);
        if (applyTagList.length > 0 && removeTagList.length > 0) {
            await AssetService.updateassettags(currentAsset.assetId, applyTagList, true)
                .then(async response => {
                    if (response.data === true) {
                        setStatusMessage("Successfully applied Asset tags!");
                    }
                    else {
                        setStatusMessage("Failed to apply Asset tags!");
                    }
                    setShowMessage(true);

                    await AssetService.updateassettags(currentAsset.assetId, removeTagList, false)
                        .then(response2 => {
                            if (response2.data === true) {
                                setStatusMessage("Successfully updated Asset tags!");
                            }
                            else {
                                setStatusMessage("Failed to remove Asset tags!");
                            }

                            setShowTagModal(false);
                            setTagsLoading(false);
                            setAppliedTags([]);
                            setUnappliedTags([]);
                            setApplyTagList([]);
                            setRemoveTagList([]);
                            //populateAssetData();

                            setTimeout(() => {
                                setStatusMessage('');
                                setShowMessage(false);
                            }, 3000);

                        })
                        .catch(e => {
                            console.log(e);
                        });

                })
                .catch(e => {
                    console.log(e);
                    setTagsLoading(false);
                });
        }
        else if (applyTagList.length > 0) {
            await AssetService.updateassettags(currentAsset.assetId, applyTagList, true)
                .then(async response => {
                    if (response.data === true) {
                        setStatusMessage("Successfully applied Asset tags!");
                    }
                    else {
                        setStatusMessage("Failed to apply Asset tags!");
                    }
                    setShowMessage(true);
                    setShowTagModal(false);
                    setTagsLoading(false);
                    setAppliedTags([]);
                    setUnappliedTags([]);
                    setApplyTagList([]);
                    setRemoveTagList([]);

                    setTimeout(() => {
                        setStatusMessage('');
                        setShowMessage(false);
                    }, 3000);

                    

                })
                .catch(e => {
                    console.log(e);
                    setTagsLoading(false);
                });
        }
        else if (removeTagList.length > 0) {
            await AssetService.updateassettags(currentAsset.assetId, removeTagList, false)
                .then(response2 => {
                    if (response2.data === true) {
                        setStatusMessage("Successfully updated Asset tags!");
                    }
                    else {
                        setStatusMessage("Failed to remove Asset tags!");
                    }
                    setShowMessage(true);

                    setShowTagModal(false);
                    setTagsLoading(false);
                    setAppliedTags([]);
                    setUnappliedTags([]);
                    setApplyTagList([]);
                    setRemoveTagList([]);

                    setTimeout(() => {
                        setStatusMessage('');
                        setShowMessage(false);
                    }, 3000);

                })
                .catch(e => {
                    console.log(e);
                });
        }
    }

    const handleApplyTags = (e) => {
        const tagId = e.target.value;

        if (e.target.checked) {
            let newApplyList = applyTagList;
            newApplyList.push(tagId);
            setApplyTagList(newApplyList);
        }
    }

    const handleRemoveTags = (e) => {
        const tagId = e.target.value;

        if (e.target.checked) {
            let newRemoveList = removeTagList;
            newRemoveList.push(tagId);
            setRemoveTagList(newRemoveList);
        }
    }
    
    const onShowCreateAlertModal = () => {
        setShowCreateAlertModal(!showCreateAlertModal);
    }
    
    const onCreateAlertClick = async () => {
        await AlertService.getalerttypes()
            .then(response => {
                if (response !== null && response !== undefined) {
                    setAlertTypes(response.data);
                }
                setShowCreateAlertModal(true);
            })
            .catch(e => {
                console.log(e);
            });
    }
    
    const onCreateAlert = async (newAlert) => {
        setShowCreateAlertModal(false);
        setContentLoading(true);
        await AlertService.addalert(newAlert)
            .then(response => {
                if (response.status === 200) {
                    setStatusMessage(`Successfully added new alert to assetId: ${newAlert.sourceId}`);
                }
                else {
                    setStatusMessage(`Failed to add new alert to assetId: ${newAlert.sourceId}.`);
                }
                setShowMessage(true);
                setContentLoading(false);
                
                setTimeout(() => {
                    setStatusMessage("");
                    setShowMessage(false);
                }, 3000);
            })
            .catch(e => {
                console.log(e);
                setStatusMessage(`Failed to add new alert to assetId: ${newAlert.sourceId}.`);
                setShowMessage(true);
                setContentLoading(false);

                setTimeout(() => {
                    setStatusMessage("");
                    setShowMessage(false);
                }, 3000);
            });
    }
    
    const onShowOperationalizeModal = () => {
        setShowOperationalizeModal(!showOperationalizeModal);
    }
    
    const onOperationalizeClick = () => {
        setModalMessage("Would you like to remove the Trained Class and apply the Operational class to this asset?");
        setModalTitle("Operationalize Asset");
        setShowOperationalizeModal(true);
    }
    
    const operationalize = async () => {
        // remove trained and add operational
        setContentLoading(true);
        let operationalList = [process.env.REACT_APP_OPERATIONAL_CLASS_ID];
        let trainedList = [process.env.REACT_APP_TRAINED_CLASS_ID];
        await AssetService.applyclasses(currentAsset.assetId, operationalList)
            .then(async response => {
                if (response.data === true) {
                    setStatusMessage("Successfully applied Operational class!");
                }
                else {
                    setStatusMessage("Failed to apply Operational class!");
                }
                setShowMessage(true)

                await AssetService.removeclasses(currentAsset.assetId, trainedList)
                    .then(response2 => {
                        if (response2.data === true) {
                            setStatusMessage("Successfully updated Trained class!");
                        }
                        else {
                            setStatusMessage("Failed to remove Trained class!");
                        }

                        setShowOperationalizeModal(false);
                        setContentLoading(false);
                        
                        setTimeout(() => {
                            setStatusMessage('');
                            setShowMessage(false);
                        }, 3000);

                    })
                    .catch(e => {
                        console.log(e);
                        setContentLoading(false);
                    });

            })
            .catch(e => {
                console.log(e);
                setContentLoading(false);
            });
    }
    
    const onShowTestModal = () => {
        setShowTestModal(!showTestModal);
    }
    
    const onRunTestClick = () => {
        setShowTestModal(true);
    }
    
    
    // end expand button 
    const onEditTagsClick = async () => {
        await AlertService.getalerttags("asset")
            .then(response => {
                if (_isMounted) {
                    let tagList = response?.data;
                    let assetTags = currentAsset.tagList !== null && currentAsset.tagList !== undefined ? JSON.parse(currentAsset.tagList) : [];
                    let appliedTagsList = [];
                    for (let i = 0; i < assetTags.length; i++) {
                        let assetTag = assetTags[i];
                        let tag = tagList.find(t => t.id === assetTag.id);
                        if (tag !== null && tag !== undefined) {
                            appliedTagsList.push(tag);
                        }
                    }
                    let unappliedTagsList = tagList.filter(t => !appliedTagsList.some(a => a.id === t.id));
                    setAppliedTags(appliedTagsList);
                    setUnappliedTags(unappliedTagsList);
                    setShowTagModal(true);
                }
            })
            .catch(e => {
                console.log(e);
            });
    }
    
    function convertToCSV(data, headers) {
        if (!data || !data.length || !workflowHeaders || !workflowHeaders.length) return '';
        const headerRow = workflowHeaders.map(h => `"${h.label}"`).join(',');
        const rows = data.map(row =>
            workflowHeaders.map(h => {
                const val = row[h.key] !== undefined && row[h.key] !== null ? row[h.key] : '';
                return `"${String(val).replace(/"/g, '""')}"`;
            }).join(',')
        );
        return [headerRow, ...rows].join('\n');
    }

    function downloadCSV(data) {
        
        Event("Download Data Clicked", "User clicked download data button in Partner Energy Metrics", "Download Data Clicked");
        const selectedPartner = props.partners.find(p => p.organizationId === props.currentPartnerId);
        
        let partnerStr = "";
        
        if (selectedPartner !== undefined && selectedPartner != null && selectedPartner.company !== null) {
            partnerStr = selectedPartner.company 
        }
        if (selectedPartnerOption?.value == 0)
        {
            partnerStr = "AllPartners"
        }
        var filenameWithDate = partnerStr + "_" + "Summary";
        var modifiedData = data;
        const csvContent = "data:text/csv;charset=utf-8," + encodeURIComponent(convertToCSV(modifiedData));

        const link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", filenameWithDate || "data.csv");
        document.body.appendChild(link);
        link.click();
    };
    
    const getExpandContent = (index, asset) => {
        let assetClasses = asset.classList !== null && asset.classList !== undefined ? JSON.parse(asset.classList) : [];
        let assetClassContent = assetClasses !== null && assetClasses.length > 0 ?
            <div>
                {assetClasses.map((classObj) => 
                    <p key={classObj.name}>
                        <span className={"color-grey"}>{classObj.name}</span><br />
                    </p>
                )}
            </div>
            : <p>
                <span className={"color-grey"}>No Applied Classes</span><br />
            </p>
        let assetTags = asset.tagList !== null && asset.tagList !== undefined ? JSON.parse(asset.tagList) : [];
        let assetTagsContent = assetTags !== null && assetTags.length > 0 ?
            <div>
                {assetTags.map((tagObj) =>
                    <p key={tagObj.label}>
                        <span className={"color-grey"}>{tagObj.label}</span><br />
                    </p>
                )}
            </div>
            : <p>
                <span className={"color-grey"}>No Applied Tags</span><br />
            </p>
        
        let content = <td colSpan={10} className={"color-unset"}>
            <div className="row">
                <div className="col">
                    <h6 className="db-blue">Classes</h6>
                    <p>
                        <span className={"color-grey"}>{assetClassContent}</span><br />
                    </p>
                </div>
                <div className="col">
                    <h6 className="db-blue">Tags</h6>
                    <p><span className={"color-grey"}>{assetTagsContent}</span><br />
                    </p>

                </div>
                <div className="col">
                    <h6 className="db-blue">Verification</h6>
                    <p><span className={"color-grey"}>Published Date</span><br />
                        {asset.publishDate !== null && asset.publishDate !== undefined ? asset.publishDate : "Not Published"}
                    </p>
                    <p><span className={"color-grey"}>Runs</span><br />
                        {assetAlertCount}
                    </p>
                    <p><span className={"color-grey"}>Alerts</span><br />
                        {assetEventCount}
                    </p>

                </div>
                <div className="col-2">
                    <h6 className="db-blue">Take Action</h6>
                    <div>
                        <div>
                            <button className="comment-btn secondary-btn btn-small width-100" onClick={onEditClassesClick}>Edit Classes</button>
                        </div>
                        <div>
                            <button className="comment-btn secondary-btn btn-small width-100" onClick={onEditTagsClick}>Edit Tags</button>
                        </div>
                        <div>
                            <button className="comment-btn secondary-btn btn-small width-100" onClick={onOperationalizeClick}>Operationalize</button>
                        </div>
                        <div>
                            <button className="comment-btn secondary-btn btn-small width-100" onClick={onRunTestClick}>Run Test</button>
                        </div>
                        <div>
                            <button className="comment-btn secondary-btn btn-small width-100" onClick={onCreateAlertClick}>Create Alert</button>
                        </div>
                    </div>
                </div>
            </div>
        </td>;
        
        return (
            <tr className="expanded background-white" key={`expandedContent-${index}`}>
                {content}
            </tr>
        )
    }
    
    let tableOptionsContent = <div className={"alerts-tab-options"}>
                <span className={"alerts-tab-select height-40"} >
                    <Select
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={AssetStateOptions}
                        onChange={changeAssetStateFilter}
                        defaultValue={selectedAssetStateOption}
                        value={selectedAssetStateOption}
                    />
                </span>

        <span className={"alerts-tab-select height-40"}>
                    <Select
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={AssetTypeOptions}
                        onChange={changeAssetTypeFilter}
                        defaultValue={selectedAssetTypeOption}
                        value={selectedAssetTypeOption}
                    />
                </span>
        <span className={"alerts-tab-select"}>
                    <Select
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={partnerOptions}
                        onChange={changePartnerFilter}
                        defaultValue={selectedPartnerOption}
                        value={selectedPartnerOption}
                    />
                </span>

        <span>
                     <div className={"text-center display-flex"}>
                         <div className="margin-left-10 margin-right-5 line-height-40">Start:</div>
                         <DatePicker
                             customInput={<input className="txt-detail datepicker height-40 margin-bottom-0" />}
                             id="startDate"
                             name="startDate"
                             selected={startTime.toDate()}
                             onChange={date => { onChangeStart(date); }}
                             dateFormat="MM/dd/yyyy h:mm:ss aa"
                             timeIntervals={15}
                             showTimeSelect
                             popperPlacement="top-end"
                             popperProps={{
                                 positionFixed: true
                             }}
                         />
                     </div>
                </span>
        <span>
                    <div className={"text-center display-flex"}>
                        <div className="margin-left-10 margin-right-5 line-height-40">End:</div>
                        <DatePicker
                            customInput={<input className="txt-detail datepicker height-40 margin-bottom-0" />}
                            id="endDate"
                            name="endDate"
                            selected={endTime.toDate()}
                            onChange={date => { onChangeEnd(date); }}
                            dateFormat="MM/dd/yyyy h:mm:ss aa"
                            timeIntervals={15}
                            showTimeSelect
                            popperPlacement="top-end"
                            popperProps={{
                                positionFixed: true
                            }}
                        />
                    </div>
                </span>

        <button className="alerts-tab-btn secondary-btn btn-small height-40" onClick={onApplyFilters} disabled={!filterChanged}>Apply Filters</button>
    </div>;
    
    function GetAssetClass(asset) {
        let classStr = "";
        
        if (asset.classList !== null && asset.classList !== undefined) {
            let assetClasses = JSON.parse(asset.classList);
            if (assetClasses !== null && assetClasses !== undefined && assetClasses.length > 0) {
                let classes = assetClasses.filter(c => assetStateList.includes(c.name)).map(s => s.name);
                if (classes !== null && classes.length > 0) {
                    classStr = classes.join(", ");
                }
            }
        }
        return classStr;
    }

    function GetCTLabel(asset) {
        let ctLabel = "1 CT";
        
        if (asset.classList !== null && asset.classList !== undefined) {
            let assetTags = JSON.parse(asset.tagList);
            if (assetTags !== null && assetTags !== undefined && assetTags.length > 0) {
                const has3CT = assetTags.some(tag => tag.label === "3CT");

                if (has3CT) {
                    ctLabel = "3 CT"
                }
            }
        }
        return ctLabel;
    }
    
    const tableColumns = [
        { field: 'lifepulseInstallDate', header: 'INSTALL DATE', className: 'table-shrink pad-10-0 min-width-80', rowClassName: 'border-left pad-16-0-16-2', sortType: ColumnSortTypes.DATE },
        { 
            field: 'state', 
            header: 'STATE', 
            sortType: ColumnSortTypes.ALPHABETICAL,
            render: (row) => <span>{GetAssetClass(row)}</span>
        },
        { field: 'partner', header: 'PARTNER', sortType: ColumnSortTypes.ALPHABETICAL },
        { field: 'customer', header: 'CUSTOMER', sortType: ColumnSortTypes.ALPHABETICAL },
        { field: 'description', header: 'MAC ID', sortType: ColumnSortTypes.ALPHABETICAL },
        { field: 'make', header: 'MAKE', sortType: ColumnSortTypes.ALPHABETICAL },
        { field: 'model', header: 'MODEL', sortType: ColumnSortTypes.ALPHABETICAL },
        { field: 'ctLabel', header: 'CT LABEL', sortType: ColumnSortTypes.ALPHABETICAL },
        { field: 'status_', header: 'STATUS', sortType: ColumnSortTypes.ALPHABETICAL },
        {
            field: 'isActive',
            header: '',
            sortable: false,
            className: 'table-shrink text-center pad-10-10-10-5',
            rowClassName: 'alerts-td-right',
            render: (row, index) => index === isSelected ?
                <ArrowUpIcon className="db-blue-reverse border-radius-12"  /> 
                : <ArrowDownIcon className="db-blue db-blue-bg border-radius-12"  />
        }
    ]
    
    const tableContent = <div></div>;
    
    const table2 = <div className={"margin-20-30"}>

        <div>
            <table className="table-hover width-100p">

                <thead>
                <tr className="alerts-table-row">
                    <th className="table-shrink text-center pad-10-0 min-width-80">
                        <div>
                            <span className={"cursor-pointer"}>INSTALL DATE</span>
                        </div>
                    </th>
                    <th>
                        <div>
                            <span className={"cursor-pointer"}>CUSTOMER</span>
                        </div>
                    </th>
                    <th>
                        <div >
                            <span className={"cursor-pointer"}>MAKE</span>
                        </div>
                    </th>
                    <th>
                        <div>
                            <span className={"cursor-pointer"}>MODEL</span>
                        </div>
                    </th>
                    <th>
                        <div>
                            <span className={"cursor-pointer"}>CT Label</span>
                        </div>
                    </th>
                    <th>
                        <div>
                            <span className={"cursor-pointer"}>MAC ID</span>
                        </div>
                    </th>
                    <th>
                        <div>
                            <span className={"cursor-pointer"}>STATUS</span>
                        </div>
                    </th>
                    <th className="table-shrink text-center pad-10-10-10-5"></th>
                </tr>
                </thead>

                {/*alertsContent*/}

            </table>
        </div>
    </div>;
    
    return (

        <div>
            <div className='infoPage'>
                <div className="row no-gutters">
                    <div className="col">
                        <h2 className="pageTitle pageTitle-border-none" id="tabelLabel">
                            Asset State Tool
                        </h2>
                    </div>
                    <div className="col asset-header-col" >
                        <button
                            className="primary-btn btn-small workflow-stage-btn"
                            onClick={assetworkflowstage}
                            disabled={workflowLoading}
                        >
                            {workflowLoading ? "Loading..." : "Workflow Stage"}
                        </button>
                    </div>
                </div>
                <div>
                    <CommonExpandTable data={assetList} columns={tableColumns} tableOptionsContent={tableOptionsContent} itemsPerPage={20} 
                        onRowClick={onAssetClick} selected={isSelected} getExpandContent={getExpandContent} clearSelected={clearSelected}
                    />
                </div>
            </div>
            {contentLoading ? <Loader/> : null}

            <UpdateAssetClassModal onClick={onShowClassModal} show={showClassModal} onCancelClick={onCancelClassModal}
                                    appliedClasses={appliedClasses} unappliedClasses={unappliedClasses}
                                   onUpdateClasses={updateClasses} handleApply={handleApplyClasses} handleRemove={handleRemoveClasses} updateLoading={classesLoading} >
            </UpdateAssetClassModal>

            <UpdateTagsModal onClick={onShowTagModal} show={showTagModal} appliedTags={appliedTags} unappliedTags={unappliedTags}
                                   onUpdateTags={updateTags} handleApply={handleApplyTags} handleRemove={handleRemoveTags} updateLoading={tagsLoading} >
            </UpdateTagsModal>
            
            <CreateAlertModal show={showCreateAlertModal} onYes={onCreateAlert} onClick={onShowCreateAlertModal} alertTypes={alertTypes} assetId={currentAsset.assetId}/>

            <ConfirmationModal show={showOperationalizeModal} onYes={operationalize} onClick={onShowOperationalizeModal} message={modalMessage} title={modalTitle}> </ConfirmationModal>
            <CommonModal show={showTestModal} onYes={doNothing} onClick={onShowTestModal} content={<Provisioning  currentPartnerId={currentAsset.partnerId} currentCustomerId={currentAsset.orgId} roles={roles} isModal={true} />} title={'Provisioning Test'} />

            <Snackbar open={showMessage} message={statusMessage} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000} />
        </div>
    );
}

export default AssetStateTool;